export enum EdgeToggleType {
  ALL,
  OFF,
  RELATED
}

export enum OtherLinksMode {
  DIMMED = 0,
  DIMMED_UNLABELED = 1,
  HIDDEN = 2
}

export enum OtherNodesMode {
  SHOWN = 0,
  DIMMED = 1,
  DIMMED_UNLABELED = 2
}
